import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";

import ResetIcon from "assets/icons/reset.svg?react";
import ResetSmallIcon from "assets/icons/reset-small.svg?react";

import { ControlsBarProps } from "./ControlsBar.types";

import { Button } from "shared/ui/components/Button";
import { Loader } from "shared/ui/components/Loader";

import styles from "./ControlsBar.module.scss";

const ControlsBar = ({ submitLoading }: ControlsBarProps) => {
  const { t } = useTranslation();
  const { resetForm } = useFormikContext();

  return (
    <div className={styles.buttonsWrapper}>
      <Button
        className={styles.resetButton}
        variant="tertiary"
        size="small"
        type="button"
        onClick={resetForm}
      >
        <span className={styles.resetMobile}>
          <ResetSmallIcon />
        </span>
        <span className={styles.resetDesktop}>
          <ResetIcon />
          {t("calculator_form.controls_bar.reset_changes")}
        </span>
      </Button>
      <Button
        type="submit"
        variant="black"
        size="small"
        className={styles.acceptButton}
      >
        {submitLoading ? (
          <Loader size={20} color="#fff" />
        ) : (
          t("calculator_form.controls_bar.run_computation")
        )}
      </Button>
    </div>
  );
};

export default ControlsBar;
